import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const NewWorkflowForm = withSafeSuspense(lazy(
  async () => ({ default: (await import('./new')).NewWorkflowForm })
))
